import React from "react";
import dayjs from "dayjs";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import Badge from "components/badge";
import { IconButton } from "components/button";
import { formatDate } from "utils/format";

export const ADMIN_ROLES = ["admin", "sub_admin", "super_admin"];

const ROLE_LABELS = {
  admin: "Admin",
  sub_admin: "Admin",
  super_admin: "Admin",
  staff: "Staff",
  elder: "Elder",
  deacon: "Deacon",
  volunteer: "Volunteer",
};

export const roleLabel = (role) => ROLE_LABELS[role] || role;

export const fullName = (person) =>
  [person?.firstName, person?.lastName].filter(Boolean).join(" ");

export const QUESTION_TYPES = [
  { value: "text", label: "Open Text" },
  { value: "scale", label: "Scale 1–5" },
  { value: "yes_no", label: "Yes / No" },
  { value: "select", label: "Multiple Choice" },
];

export const questionTypeLabel = (type) =>
  QUESTION_TYPES.find((t) => t.value === type)?.label || type;

/** Monday of the week containing `date`, as the API's `YYYY-MM-DD` week key. */
export const mondayOf = (date) => {
  const d = dayjs(date);
  const dow = d.day(); // 0 = Sunday
  return d.subtract(dow === 0 ? 6 : dow - 1, "day").format("YYYY-MM-DD");
};

/** This week's check-in state for someone who reports to a leader. */
export const CheckInBadge = ({ submitted, size = "sm" }) =>
  submitted ? (
    <Badge tone="success" size={size} dot>
      Checked In
    </Badge>
  ) : (
    <Badge tone="warning" size={size} dot>
      Pending
    </Badge>
  );

/** Previous/next week controls around a "Week of …" label; future weeks are disabled. */
export const WeekStepper = ({ weekStart, onChange }) => {
  const currentWeek = mondayOf(new Date());
  return (
    <div className="flex items-center gap-2">
      <IconButton
        icon={<MdChevronLeft className="h-5 w-5" />}
        label="Previous week"
        variant="secondary"
        onClick={() => onChange(mondayOf(dayjs(weekStart).subtract(7, "day")))}
      />
      <span className="min-w-[150px] text-center text-sm font-semibold text-fg" aria-live="polite">
        Week of {formatDate(weekStart)}
      </span>
      <IconButton
        icon={<MdChevronRight className="h-5 w-5" />}
        label="Next week"
        variant="secondary"
        disabled={weekStart >= currentWeek}
        onClick={() => onChange(mondayOf(dayjs(weekStart).add(7, "day")))}
      />
    </div>
  );
};
